var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step"},[(_vm.checkPassed || _vm.is_online === 1)?_c('p',{staticClass:"successResult"},[_vm._v("恭喜您通过了本次考前测试，请点击完成提交结果。")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }